import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraBadge, SpecraLink } from '@mono/ui-components/ensigns';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { registryHref } from '../../registryHref';
export const monthYear = (t)=>t?.toDate().toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    }) ?? '';
export const fractionalYear = (t)=>{
    const date = t.toDate();
    const year = date.getUTCFullYear();
    const start = Date.UTC(year, 0, 1);
    return year + (date.getTime() - start) / (Date.UTC(year + 1, 0, 1) - start);
};
// Invert elapsed-year coordinates, including leap years, rather than treating them as twelfths.
export const formatVehicleTime = (t)=>{
    const year = Math.floor(t);
    const start = Date.UTC(year, 0, 1);
    const elapsed = Math.round((t - year) * (Date.UTC(year + 1, 0, 1) - start));
    return new Date(start + elapsed).toLocaleDateString('en-US', {
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    });
};
/**
 * Who may order on a vehicle, for display. The dossier carries the stored value as written
 * (often an enum-like `UNKNOWN` / `VA_ONLY`); unknown reads as nothing, enums read as words.
 */ export function orderingEligibilityLabel(value) {
    const v = (value ?? '').trim();
    if (!v || /^unknown$/i.test(v)) return '';
    if (/^[A-Z0-9_]+$/.test(v)) {
        const words = v.toLowerCase().split('_').filter(Boolean).join(' ');
        return words.charAt(0).toUpperCase() + words.slice(1);
    }
    return v;
}
export function VehicleRefLink({ value, label }) {
    const href = value && registryHref(value);
    const text = label ?? value?.name ?? '';
    return href ? /*#__PURE__*/ _jsx(SpecraLink, {
        href: href,
        renderLink: renderRouterLink,
        children: text
    }) : text;
}
/** Missing from the successor is only a risk for a company that holds this vehicle. */ export const missingSuccessor = (row)=>row.holdingThis !== 'NOT_ON_IT';
// specra-allow local-composite: Maps vehicle holding states to SpecraBadge labels and semantic variants.
export function HoldingBadge({ status, danger = false }) {
    const label = status === 'HOLDER' ? 'Holder' : status === 'THROUGH' ? 'Through teammate' : status === 'PRICE_LIST_ONLY' ? 'Price list only' : 'Not on it';
    return /*#__PURE__*/ _jsx(SpecraBadge, {
        variant: status === 'HOLDER' ? 'success' : status === 'NOT_ON_IT' && danger ? 'danger' : 'neutral',
        children: label
    });
}
